import ILocale from "./ILocale";

export const EnTranslation: ILocale = {
  home: {
    title: "Hey, I'm Facundo Herrera 🚀",
    subtitle: "University Technician in Programming | FRT-UTN",
    content: {
      first:
        "I'm a software developer based in Tucumán - Argentina 🍋, graduated in National Technological University of Argentina (UTN) as University Technician in Programming.",
      second:
        "My technical profile is mainly composed of frontend web and backend technologies, also I have experience working in mobile development (native and hybrid).",
      third:
        "In Frontend web area I've worked with special focus in React Framework with latest specifications as Hooks and its intersection with Redux and Sagas. Also I've worked with Nextjs and Styled Components, React Query, SWR and Context API.",
      fourth:
        "In backend area I'm working with Nodejs, express and typescript. Also I've worked with .Net and Laravel frameworks on monolitic and microservices projects, as well I've worked with SQL query languages and Orms.",
      fifth:
        "I like all about software world, I usually listen to podcast about tech news, among which are",
      six: {
        first: "For more information you can send me a email to",
        second: "also you can read",
        third: "or contact me at the links below",
      },
    },
  },
};
